import {computeColorCode, getCardStyle, getTrendData} from "@/pages/mindmap/CarNodes/nodeUtils.ts";
import MiniSparkline from "@/pages/mindmap/CarNodes/SparkLine/MiniSparkline.tsx";
import {Metric, TreeNode} from "@/types";
import React from "react";
import RightArrow from "@/assets/icons/RightArrow.tsx";
import {CompactUnit, formatCompactNumber, formatPercentage} from "@/utils/format.ts";
import {COLOR_MAP} from "@/pages/mindmap/constant.ts";
import {Handle, Position} from "@xyflow/react";


export const get_color = (key: string, datas: Record<string, Metric>) => {
    if (key in datas) {
        const code = computeColorCode(datas[key].metric_name, datas[key].value)
        // return COLOR_MAP[datas[key].color]
        return COLOR_MAP[code]
    } else {
        return {color: '#64748b', fontWeight: 700}
    }
}

export const render_line = (
    l1: string,
    l2: string, datas: Record<string, Metric>,
    is_plan: boolean = false,
    targetUnit: CompactUnit = 'M'
) => {
    // 拼接指标key的时候有的中间需要这个 amt，有的不需要,
    // const middle_amt = l1 == "nts" ? 'amt_' : '';
    let vol_gro_key = `${l1}_${l2}_vol_growth`
    if (l1 == "nts") {
        vol_gro_key = `${l1}_amt_${l2}_vol_growth`
    }
    if (is_plan) {
        // vol_gro_key="ims_amt_mtd_vol_growth_mip"
        vol_gro_key = "ims_mtd_vol_growth"
        if (formatPercentage(datas[vol_gro_key]?.value) == "--") {
            vol_gro_key = "ims_amt_mtd_vol_growth"
        }
    }

    return <div>
        {/*特殊类型处理 ims_vbp 变为 vbp  ims_vbp_amt_mtd*/}
        <span>{l2.toUpperCase()} {l1.replace("ims_", "").toUpperCase().replace("NONVBP", "Non-VBP")} </span>
        <span style={get_color(`${l1}_amt_${l2}`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}`]?.value, 1, targetUnit)}</span>
        <span>, Gap </span>
        <span style={get_color(`${l1}_amt_${l2}_gap`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}_gap`]?.value, 1, targetUnit)}
            </span>
        <span>, Achi </span>
        <span style={get_color(`${l1}_amt_${l2}_achi`, datas)}>
                {formatPercentage(datas[`${l1}_amt_${l2}_achi`]?.value)}
            </span>
        <span>, Vol Gro </span>
        <span style={get_color(vol_gro_key, datas)}>
                {formatPercentage(datas[vol_gro_key]?.value)}
            </span>
    </div>
}

interface Props {
    node: TreeNode,
    isCategory?: boolean,
    showChart?: boolean,
    showTitle?: boolean,
    extra?: React.ReactElement,
    children?: React.ReactElement,
    cardStyle?: React.CSSProperties,
    data?: { expanded?: boolean; hasChildren?: boolean },
}


export const BasicCardNode = (
    {
        node,
        isCategory = false,
        showChart = false,
        showTitle = true,
        extra,
        children,
        cardStyle = getCardStyle(node, isCategory),
        data,
    }: Props) => {

    const trendData = showChart ? getTrendData(node) : null
    const isExpanded = data?.expanded;
    const canExpand = data?.hasChildren;

    if (node.id =="wch-vbp-province-qinghai"){
        console.log(trendData)
    }


    const get_chart_prefix = ()=>{
        if (node.id.includes("-vbp-")){
            return "VBP "
        } else if (node.id.includes("-nonvbp-")) {
            return "Non-VBP "
        }
        return "IMS"
    }

    return <>
        <Handle type="target" position={Position.Left} style={{background: 'transparent',border:0, width: 0, height: 0}}/>
        <div style={{...cardStyle, display: 'flex', flexDirection: 'column'}}>
            {/* Top-right: extra + expand/collapse icon */}
            {(extra || canExpand) && (
                <div style={{
                    position: 'absolute',
                    top: 12,
                    right: 14,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                }}>
                    {extra}
                    {canExpand && (
                        <span style={{
                            fontSize: 13,
                            color: '#94a3b8',
                            transform: isExpanded ? 'rotate(90deg)' : 'none',
                            transition: 'transform 0.2s ease',
                            lineHeight: 1,
                            userSelect: 'none',
                        }}>
                           <RightArrow size={18}/>
                        </span>
                    )}
                </div>
            )}
            <div style={{display: 'flex', gap: 8, flex: 1}}>
                {/* Left content */}
                <div style={{flex: 1, minWidth: 0, overflow: 'hidden'}}>
                    {/* Header row: type */}
                    {showTitle &&
                        <>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 2
                            }}>
                          <span style={{
                              fontSize: 10,
                              fontWeight: 700,
                              color: '#94a3b8',
                              textTransform: 'uppercase',
                              letterSpacing: 1
                          }}>
                            {node.type}
                          </span>
                            </div>
                            <h3 style={{fontSize: 14, fontWeight: 700, color: '#1e293b', marginBottom: 4}}>
                                {node.name}
                            </h3>
                        </>
                    }
                    {/* Description */}
                    <div style={{marginBottom: 6}}>
                        <div style={{fontSize: '10px', color: 'rgb(71, 85, 105)', lineHeight: '1.4', margin: '0px', overflowWrap: 'break-word', wordBreak: 'break-word'}}>
                            {children}
                        </div>
                    </div>
                </div>

                {/* Right sparkline */}
                {showChart && (
                    <div style={{
                        flexShrink: 0, alignSelf: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <MiniSparkline
                            status={node.status === 'good' ? 'good' : 'critical'}
                            seed={node.id}
                            actualData={trendData?.actual ?? null}
                            planData={trendData?.plan ?? null}
                            actualLabel={get_chart_prefix() + " Act"}
                            planLabel={get_chart_prefix() + " BP"}
                            title={get_chart_prefix() + " trend - Past 6 months"}
                        />
                    </div>
                )}
            </div>
        </div>
        <Handle type="source" position={Position.Right}  style={{background: 'transparent',border:0, width: 0, height: 0}}/>
    </>
}
